import clsx from 'clsx'
import React from "react"
import { ListboxButton, ListboxOption } from "@headlessui/react"

import { ListBox } from "../../../lib/fragments/ListBox"
import { dataFormatsArray } from "../../../utils/Constants"
import { AttributeRestrictions } from "../AttributeRestrictions"
import { FreetextRestriction } from './FreetextRestriction'
import { NumericRestriction } from './NumericRestriction'
import { PredefinedRestriction } from './PredefinedRestriction'

export const AttributeConfiguration = ({ state, setstate, listboxHandler, blurHandler, changeHandler }) => {
    const dataTypeHandler = (format: any) => {
        switch (format) {
            case 'freetext':
                return <FreetextRestriction
                    state={state}
                    setstate={setstate}
                    blurHandler={blurHandler}
                    changeHandler={changeHandler}
                    listboxHandler={listboxHandler}
                />

            case 'numeric':
                return <NumericRestriction
                    state={state}
                    setstate={setstate}
                    blurHandler={blurHandler}
                    changeHandler={changeHandler}
                />

            case 'predefined':
                return <PredefinedRestriction
                    state={state}
                    setstate={setstate}
                    blurHandler={blurHandler}
                    changeHandler={changeHandler}
                    listboxHandler={listboxHandler}
                />

            default:
                break;
        }
    }

    return (
        <React.Fragment>
            <div className="w-full mb-2 md:pt-0 pt-1 px-2 flex flex-col md:h-full flex-1">
                <div className="flex-grow text-sm">
                    <p className="md:text-lg text-lg text-slate-900 dark:text-white flex items-center gap-x-3 py-2">
                        <span className="fa-light fa-sliders-up fa-xl"></span>
                        Configuration
                    </p>

                    <span className="text-xs mb-2 text-slate-500 dark:text-slate-400">
                        Customize how this attribute behaves in your system.
                    </span>

                    <div className="w-full pt-3 pb-2 md:max-w-md">
                        <ListBox
                            label={
                                <span className="block text-base text-slate-800 dark:text-slate-200 pb-1">
                                    Data Type

                                    <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                        Choose the data type this attribute should support
                                    </span>
                                </span>
                            }
                            value={state.input.format ? state.input.format.key : ''}
                            eventHandler={(e: any) => listboxHandler(e, 'format')}
                            button={
                                <>
                                    <ListboxButton className="relative border w-full rounded-md py-2.5 pr-2 text-left cursor-default focus:ring-primary focus:border-primary sm:text-sm ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border-slate-300 dark:border-slate-600 dark:text-white">
                                        <div className="flex w-full items-center align-middle">
                                            <div className="flex-grow flex items-center">
                                                <span className="truncate ml-3 font-normal group-data-[selected]:font-semibold">
                                                    {
                                                        state.input.format ? (
                                                            <div className="flex items-center gap-x-4">
                                                                <span className="truncate group-data-[selected]:font-semibold">
                                                                    {state.input.format.label}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-slate-600 dark:text-slate-300">
                                                                Data Type
                                                            </span>
                                                        )
                                                    }
                                                </span>
                                            </div>

                                            <span className="fa-light fa-chevron-down focus:text-primary float-end"></span>
                                        </div>
                                    </ListboxButton>
                                </>
                            }
                            options={
                                <>
                                    {
                                        dataFormatsArray.map((dataType: any) => (
                                            <ListboxOption key={`attr-data-type-${dataType.key}`} value={dataType} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                                <div className="flex items-center gap-x-4">
                                                    <span className="truncate group-data-[selected]:font-medium">
                                                        {dataType.label}

                                                        <span className="block text-xs text-slate-500 dark:text-slate-400">
                                                            {dataType.desc}
                                                        </span>
                                                    </span>
                                                </div>

                                                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                    <span className="fa-light fa-check"></span>
                                                </span>
                                            </ListboxOption>
                                        ))
                                    }
                                </>
                            }
                        />

                        {
                            state.errors.format.length > 0 && (
                                <span className='invalid-feedback text-xs text-red-600 dark:text-red-400 pl-1 pt-1'>
                                    {state.errors.format}
                                </span>
                            )
                        }
                    </div>

                    <div className={clsx(
                        "transition-all duration-300 mt-3 ease-in-out overflow-hidden rounded-md w-full",
                        state.input.format ? "opacity-100" : "max-h-full opacity-0"
                    )}>
                        <span className="block text-sm text-slate-800 dark:text-slate-200 pb-3">
                            <span className="block text-base">Restrictions</span>

                            <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                {state.input.format?.desc}
                            </span>
                        </span>
                        {
                            dataTypeHandler(state.input.format?.key)
                        }
                    </div>
                </div>

                {
                    state.errors.configuration.length > 0 && (
                        <div className="flex-none">
                            <span className='text-xs py-2 px-2 rounded-md mb-3 flex align-middle items-center bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-400 gap-x-2'>
                                <span className="fa-regular fa-exclamation-circle fa-lg"></span>

                                {state.errors.configuration}
                            </span>
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    )
}